// src/project/data/fetches/notifications.js
// GET /message/list/user?userId={userId}&group=ultraxeno
import { buildUrlWithAuth, getUserId } from '../config/apiConfig'

export default {
  url() {
    const userId = getUserId()
    return buildUrlWithAuth('/message/list/user', { userId, target:"rider" })
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: 200,
        data: { notifications: [], count: { total: 0, unread: 0, read: 0 } },
      }
    }
    const d = raw?.data || {}
    const notifications = (d.notifications || []).map(n => ({
      id: n.id,
      title: n.title || '',
      message: n.message || '',
      type: n.type || 'info',
      audience: n.audience || 'broadcast',
      isRead: !!n.isRead,
      readAt: n.readAt || null,
      createdAt: n.createdAt,
      data: n.data || {},
    }))
    return {
      statusCode: 200,
      data: {
        notifications,
        count: d.count || { total: notifications.length, unread: 0, read: 0 },
      },
    }
  },
}
